<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        :rules="rules"
        ref="ruleForm"
      >
        <a-form-model-item label="Name / Tên nhóm" prop="name">
          <a-input v-model="form.name" placeholder="Write name..." />
        </a-form-model-item>
      </a-form-model>
      <a-divider orientation="left">
        Information
      </a-divider>
      <a-descriptions :column="1">
        <a-descriptions-item label="Created by">
          {{ form.author && (form.author.fullname || form.author.username) }}
        </a-descriptions-item>
        <a-descriptions-item label="Created at">
          {{ form.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Updated at">
          {{ form.updatedAt | formatDateHour }}
        </a-descriptions-item>
      </a-descriptions>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Confirm action?"
          ok-text="Delete"
          cancel-text="Cancel"
          @confirm="onDelete"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left;"
            :loading="loadingBtn"
          >
            Delete
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" @click="close">
          Close
        </a-button>
        <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
          Update
        </a-button>
      </div>
    </div>
  </a-skeleton>
</template>
<script>
import query from "../constant/query";
import moment from "moment";
const rules = {
  name: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
};

function range(start, end) {
  var ans = [];

  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

const nowYear = new Date().getFullYear();
const listYears = range(+nowYear - 5, +nowYear + 5);
export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    idItem: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      moment,
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      listYears,
      loading: false,
      loadingBtn: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdate();
        } else {
          return false;
        }
      });
    },
    onUpdate() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateHelpdeskCategoryGroup,
          variables: {
            id: this.form.id,
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loadingBtn = false;
          if (data?.updateHelpdeskCategoryGroup?.id) {
            this.refreshAfterUpdated(data.updateHelpdeskCategoryGroup);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Cập nhật thông tin không thành công", err);
        });
    },
    onGetItem() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getHelpdeskCategoryGroup,
          variables: { id: this.idItem },
        })
        .then(({ data }) => {
          this.loading = false;
          if (data?.getHelpdeskCategoryGroup?.id) {
            this.form = { ...data.getHelpdeskCategoryGroup };
            if (this.form?.year) {
              this.$set(this.form, "year", this.form.year.toString());
            }
            if (this.form.startDate && this.form.endDate) {
              this.$set(this.form, "rangeDate", [
                this.form.startDate,
                this.form.endDate,
              ]);
            }
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Lấy chi tiết thông tin không thành công", err);
        });
    },
    onDelete() {
      if (this?.form?.id) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteHelpdeskCategoryGroup,
            variables: {
              id: this.form.id,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Success",
              description: "Deleted Success!",
            });
            this.loadingBtn = false;
            if (data?.deleteHelpdeskCategoryGroup?.id) {
              this.refreshAfterDeleted(data.deleteHelpdeskCategoryGroup);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Error",
              description: "Updated Error!",
            });
            console.log("Xóa thông tin không thành công", err);
          });
      }
    },
    // onChangeStartDate(value) {
    //   this.$set(this.form, "startDate", value);
    //   this.calTotalDay();
    // },
    // onChangeEndDate(value) {
    //   this.$set(this.form, "endDate", value);
    //   this.calTotalDay();
    // },
    onChangeYear(value) {
      this.$set(this.form, "year", value);
    },
    calTotalDay() {
      if (this.form.startDate && this.form.endDate) {
        const startDate = moment(this.form.startDate).set({
          hour: 0,
          minute: 0,
        });
        const endDate = moment(this.form.endDate).set({ hour: 23, minute: 59 });
        this.$set(this.form, "duration", endDate.diff(startDate, "days") + 1);
      }
    },
    onChangeRangeDate(arrayDate) {
      if (arrayDate) {
        const startDate = arrayDate[0];
        const endDate = arrayDate[1];
        this.$set(this.form, "rangeDate", arrayDate);
        this.$set(this.form, "startDate", startDate);
        this.$set(this.form, "endDate", endDate);
        this.calTotalDay();
      }
    },
  },
  created() {
    this.onGetItem();
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
